var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,2c5.52,0,10,4.48,10,10s-4.48,10-10,10S2,17.52,2,12,6.48,2,12,2Zm0,2c-4.42,0-8,3.58-8,8s3.58,8,8,8,8-3.58,8-8-3.58-8-8-8Zm0,1c1.02,0,1.98.22,2.86.61l-1.56,1.56c-.41-.11-.85-.17-1.3-.17-2.76,0-5,2.24-5,5,0,1.38.56,2.63,1.46,3.54l-1.41,1.41-.16-.16c-1.17-1.25-1.89-2.94-1.89-4.79,0-3.87,3.13-7,7-7Zm6.39,4.14c.39.87.61,1.84.61,2.86,0,1.93-.78,3.68-2.05,4.95l-1.41-1.41c.9-.91,1.46-2.16,1.46-3.54,0-.45-.06-.88-.17-1.3l1.56-1.56Zm-2.15-2.8l1.41,1.41-3.72,3.73c.04.16.07.34.07.52,0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2c.18,0,.35.02.52.07l3.73-3.72h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.ef2d4603a86502495a29927306d10b79.svg";
export { ForwardRef as ReactComponent };